import { Routes } from '@angular/router';
import { canActivateAuthGuard, workspacesGuardActivate } from '@keeps-platform-frontend-workspace/kp-keeps';
import { WorkspaceGuard } from 'app/shared/guard/workspace.guard';
import { environment } from 'environments/environment';
// This lives in my-account-lib's eager-safe `shared` subpath (no lazy route code), so this
// doesn't pull in the lazy screens.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ACTIVITY_LOG_CONFIG } from '@keeps-platform-frontend-workspace/my-account/shared';
import { myAccountActivityLogConfig } from 'app/main/activity-log/activity-log-config';

export const routes: Routes = [
  {
    path: 'workspace/profile',
    loadChildren: () => import('@keeps-platform-frontend-workspace/my-account/workspace'),
    canActivate: [canActivateAuthGuard, WorkspaceGuard],
  },
  {
    path: 'workspaces',
    loadChildren: () =>
      import('@keeps-platform-frontend-workspace/workspaces').then((m) => {
        m.WorkspacesModule.moduleConfig = {
          logoUrl: environment.workspacesPageLogo,
          environment,
          isMyAccount: true,
        };
        return m.WorkspacesModule;
      }),
    canActivate: [canActivateAuthGuard],
    data: { layout: 'empty', roles: [] },
  },
  {
    path: 'users',
    loadChildren: () => import('@keeps-platform-frontend-workspace/my-account/users'),
    canActivate: [canActivateAuthGuard],
  },
  {
    path: 'user/profile',
    loadChildren: () =>
      import('@keeps-platform-frontend-workspace/profile').then((m) => {
        m.ProfileModule.moduleConfig = {
          keycloak: {
            url: environment.keycloakConfig.url,
            realm: environment.keycloakConfig.realm,
            clientId: environment.keycloakConfig.clientId,
          },
        };
        return m.ProfileModule;
      }),
    canLoad: [workspacesGuardActivate],
    data: {
      roles: [],
    },
  },
  {
    path: 'backoffice',
    loadChildren: () => import('./main/backoffice/backoffice.routes'),
  },
  {
    path: 'backoffice/external-providers',
    loadChildren: () => import('@keeps-platform-frontend-workspace/my-account/external-provider'),
    canActivate: [canActivateAuthGuard, WorkspaceGuard],
  },
  {
    path: 'activity-log',
    loadChildren: () => import('@keeps-platform-frontend-workspace/my-account/activity-log'),
    providers: [{ provide: ACTIVITY_LOG_CONFIG, useValue: myAccountActivityLogConfig }],
    canActivate: [canActivateAuthGuard],
    data: {
      roles: ['keeps_admin', 'company_admin'],
    },
  },
  {
    path: 'tools-hub',
    loadChildren: () => import('@keeps-platform-frontend-workspace/my-account/tools-hub'),
    canActivate: [canActivateAuthGuard],
  },
  {
    path: '**',
    redirectTo: environment.routeHome,
  },
];
